import { styled } from "styled-components";

export const RadioCardContent = styled.div<{
  $selected: boolean;
  $editable: boolean;
}>`
  cursor: ${(props) => (props.$editable ? `pointer` : "default")};
  padding: 16px;
  border-radius: 4px;
  box-shadow:
    0 0 0 1px rgba(34, 36, 38, 0.15) inset,
    0 2px 4px 0 rgba(34, 36, 38, 0.12),
    0 2px 10px 0 rgba(34, 36, 38, 0.15);

  outline: ${(props) => (props.$selected ? `2px solid #2185d0` : "none")};
  opacity: ${(props) => (props.$editable ? 1 : 0.5)};

  &:focus {
    outline: ${(props) =>
      props.$selected ? `2px solid #2185d0`
      : props.$editable ? `1px solid #2185d0`
      : "none"};
  }
  &:hover {
    outline: ${(props) =>
      props.$selected ? `2px solid #2185d0`
      : props.$editable ? `1px solid #2185d0`
      : "none"};
  }
`;

export const RadioCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
